import { useSessionData } from '@confluence/session-data';
import { ConfluenceEdition } from '@confluence/change-edition';

export const useSmartButtonPremiumGate = () => {
	const { edition } = useSessionData();

	const isPremium = edition === ConfluenceEdition.PREMIUM;

	return {
		isSmartButtonAllowed: isPremium,
	};
};
